/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '/',
      load: () => import(/* webpackChunkName: 'home' */ './home/landingpage'),
    },
    {
      path: '/FAQ',
      load: () => import(/* webpackChunkName: 'faq' */ './faq'),
    },
    {
      path: '/TentangKami',
      load: () =>
        import(/* webpackChunkName: 'tentang-kami' */ './tentang-kami'),
    },
    {
      path: '/tentangDanaPengembangan',
      load: () =>
        import(
          /* webpackChunkName: 'tentangDanaPengembangan' */ './danaPembangunan/tentangDanaPengembangan'
        ),
    },
    // {
    //   path: '/danaPinjamanAbadi',
    //   load: () =>
    //     import(/* webpackChunkName: 'danaPinjamanAbadi' */ './danaPembangunan/danaAbadi'),
    // },
    // {
    //   path: '/danaPinjamanAbadi/:id/:projectName',
    //   load: () =>
    //    import(/* webpackChunkName: 'detailCrowdFunding' */ './danaPembangunan/detailCrowdFunding'),
    // },
    {
      path: '/donorBeasiswa',
      load: () =>
        import(
          /* webpackChunkName: 'donorBeasiswa' */ './danaPembangunan/donasiBeasiswa'
        ),
    },
    {
      path: '/donorBeasiswa/:id',
      load: () =>
        import(
          /* webpackChunkName: 'detailDonorBeasiswa' */ './danaPembangunan/detailDonorBeasiswa'
        ),
    },
    {
      path: '/donasiSukarela',
      load: () =>
        import(
          /* webpackChunkName: 'donasiSukarela' */ './danaPembangunan/donasiSukarela'
        ),
    },
    {
      path: '/ProfilPengurus',
      load: () =>
        import(/* webpackChunkName: 'profil-pengurus' */ './profil-pengurus'),
    },
    {
      path: '/ProfilPengurus/detail/:id',
      load: () =>
        import(/* webpackChunkName: 'pengurusDetail' */ './profil-pengurus/detail'),
    },
    {
      path: '/Informasi',
      load: () => import(/* webpackChunkName: 'informasi' */ './informasi'),
    },
    {
      path: '/Informasi/Detail',
      load: () =>
        import(/* webpackChunkName: 'dokumen' */ './informasi/detailDokumen'),
    },
    {
      path: '/Informasi/langkah-kedepan',
      load: () => import(/* webpackChunkName: 'proyek' */ './informasi/proyek'),
    },
    {
      path: '/Informasi/:title',
      load: () =>
        import(/* webpackChunkName: 'dokumen' */ './informasi/dokumen'),
    },
    {
      path: '/pengumuman',
      load: () =>
        import(/* webpackChunkName: 'pengumuman' */ './informasi/pengumuman'),
    },
    {
      path: '/pengumuman/:id',
      load: () =>
        import(/* webpackChunkName: 'detailPengumuman' */ './informasi/detailPengumuman'),
    },
    {
      path: '/Informasi/Proyek/:title',
      load: () => import(/* webpackChunkName: 'proyek' */ './informasi/proyek'),
    },
    {
      path: '/Informasi/Proyek/detail/:id',
      load: () =>
        import(/* webpackChunkName: 'proyek' */ './informasi/proyekDetail'),
    },
    {
      path: '/CeritaKEKL',
      load: () =>
        import(/* webpackChunkName: 'CeritaKEKL' */ './home/ceritakekl'),
    },
    {
      path: '/CeritaKeklDetail/:id',
      load: () =>
        import(
          /* webpackChunkName: 'CeritaKeklDetail' */ './home/ceritakekl-detail'
        ),
    },
    {
      path: '/Jadwal',
      load: () => import(/* webpackChunkName: 'Jadwal' */ './home/jadwal'),
    },
    {
      path: '/Jadwal/DetailJadwal/:id',
      load: () =>
        import(
          /* webpackChunkName: 'DetailJadwal' */ './home/jadwal/detail-jadwal'
        ),
    },
    {
      path: '/Galeri',
      load: () => import(/* webpackChunkName: 'galeri' */ './galeri'),
    },
    {
      path: '/Galeri/Detail/:id',
      load: () =>
        import(
          /* webpackChunkName: 'detail-galeri' */ './galeri/detail-galeri'
        ),
    },
    {
      path: '/crowdFunding',
      load: () =>
        import(
          /* webpackChunkName: 'crowdFunding' */ './danaPembangunan/crowdFunding'
        ),
    },
    {
      path: '/:type/:id/:projectName',
      load: () =>
        import(
          /* webpackChunkName: 'detailCrowdFunding' */ './danaPembangunan/detailCrowdFunding'
        ),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Untitled Page'} - Portal Yayasan Loyola`;
    route.description = route.description || '';
    route.contentImage = route.contentImage || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;
